define(
({
  "load_error": "Yükleme Hatası",
  "description": "Bir talep doğru bir şekilde tamamlanmadı. Siparişinin kaydedildiğinden emin olmalı, daha sonra da bu sayfayı yenilemelisin."
})
);
